import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { API } from 'src/api';
import { useIntercomService } from 'src/api/services/intercom/intercom-service';
import { CatalogueSideBar } from 'src/components/sidebar';
import { MainLayout } from 'src/layouts/main-layout';
import { RootState } from 'src/store/reducers';
import { TOGGLE_SIDEBAR } from 'src/store/types';

export const CatalogueLayout = ({ children }: { children: JSX.Element }): JSX.Element => {
  const dispatch = useDispatch();
  useIntercomService();

  const { isSidebarOpened } = useSelector((state: RootState) => state.layout);
  const [categories, setCategories] = useState<
    {
      name: string;
      color: string;
      slug: string;
    }[]
  >([]);

  const router = useRouter();

  const handleToggleSideBar = () => {
    dispatch({ type: TOGGLE_SIDEBAR });
  };

  const isActive = (item: string) => {
    return router.query?.slug === item;
  };

  // const fetchCategories = async () => {
  //   const response = await API.get(`catalog/-1/0`);
  //   setCategories(response.data);
  // };

  // useEffect(() => {
  //   fetchCategories();
  // }, []);
  return (
    <MainLayout
      isOverView
      sidebar={
        <CatalogueSideBar
          isOpen={isSidebarOpened}
          onToggleSidebar={handleToggleSideBar}
          isActive={isActive}
          categories={categories}
        />
      }
    >
      <div className="bg-gray-100 min-h-screen overflow-auto">{children}</div>
    </MainLayout>
  );
};
